// Auto-save indicator component
import React, { useState, useEffect } from 'react';

/**
 * Component that shows visual feedback when data is being saved automatically
 * @param {Object} props - Component props
 * @param {boolean} props.isSaving - Whether data is currently being saved
 * @param {Date} props.lastSavedAt - Timestamp of when data was last saved
 */
const AutoSaveIndicator = ({ isSaving, lastSavedAt }) => {
  const [visible, setVisible] = useState(false);
  const [statusText, setStatusText] = useState('');
  
  useEffect(() => {
    if (isSaving) {
      setVisible(true);
      setStatusText('Saving...');
    } else if (lastSavedAt) {
      // Show "Saved" for 3 seconds after saving
      setVisible(true);
      setStatusText('Saved successfully');
      
      const timer = setTimeout(() => {
        setVisible(false);
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [isSaving, lastSavedAt]);
  
  if (!visible) return null;
  
  return (
    <div className="fixed bottom-4 left-4 z-50 bg-gray-800/80 backdrop-blur-sm text-white px-3 py-1.5 rounded-full text-sm shadow-lg flex items-center gap-2 transition-opacity duration-300">
      {isSaving ? (
        <>
          <div className="w-2 h-2 rounded-full bg-primary animate-pulse"></div>
          <span>Saving...</span>
        </>
      ) : (
        <>
          <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span>Saved successfully</span>
        </>
      )}
    </div>
  );
};

export default AutoSaveIndicator; 